<template>
  <div>
    <van-form label-width="62px">
      <van-field
        v-model="fom.addTime"
        readonly
        input-align="right"
        label="提交时间"
        placeholder="用户名"
      />
      <van-field
        v-model="fom.endTime"
        readonly
        input-align="right"
        label="处理时间"
        placeholder="用户名"
      />
      <van-field name="tag" input-align="right" label="工单状态">
        <template class="pp" #input>
          <van-tag v-if="fom.state == true" type="primary" size="medium">
            已处理
          </van-tag>
          <van-tag v-if="fom.state == false" color="#cccccc" size="medium">
            待处理
          </van-tag>
        </template>
      </van-field>
      <van-field
        v-model="fom.card"
        readonly
        input-align="right"
        label="问题卡号"
        placeholder="用户名"
      />

      <van-field
        v-model="fom.workOrderType"
        readonly
        input-align="right"
        label="问题类型"
        placeholder="用户名"
      />
      <van-field
        v-model="fom.data"
        rows="2"
        autosize
        readonly
        input-align="right"
        label="问题描述"
        type="textarea"
        maxlength="50"
        placeholder="请输入留言"
        show-word-limit
      />
      <van-field name="uploader" input-align="right" label="图片展示">
        <template class="pp" #input>
          <div style="width: 100%">
            <viewer :images="[fom.image1]">
              <img
                v-if="fom.image1"
                style="width: 65px; height: 65px; margin-left: 10px"
                :src="fom.image1"
                alt=""
              />
              <img
                v-if="fom.image2"
                style="width: 65px; height: 65px; margin-left: 10px"
                :src="fom.image2"
                alt=""
              />
              <img
                v-if="fom.image3"
                style="width: 65px; height: 65px; margin-left: 10px"
                :src="fom.image3"
                alt=""
              />
              <img
                v-if="fom.image4"
                style="width: 65px; height: 65px; margin-left: 10px"
                :src="fom.image4"
                alt=""
              />
              <img
                v-if="fom.image5"
                style="width: 65px; height: 65px; margin-left: 10px"
                :src="fom.image5"
                alt=""
              />
            </viewer>
          </div>
        </template>
      </van-field>

      <van-field name="radio" readonly label="联系方式">
        <template #input>
          <van-radio-group
            v-model="fom.contactInformationType"
            disabled
            direction="horizontal"
          >
            <van-radio :name="1">微信</van-radio>
            <van-radio :name="2">手机</van-radio>
            <van-radio :name="3">QQ</van-radio>
            <van-radio :name="4">邮箱</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="fom.contactInformation"
        readonly
        placeholder="请输入联系方式"
        input-align="right"
      />
      <van-field
        v-if="fom.returnInformation"
        v-model="fom.returnInformation"
        type="textarea"
        readonly
        input-align="left"
        label="返回信息"
        placeholder="用户名"
      />
    </van-form>
  </div>
</template>

<script>
  import { selectAll, select } from "@/api/cardOperation";
  export default {
    data() {
      return {
        fom: {},
        columns: [],
        current: 0,
      };
    },
    created() {},
    mounted() {
      this.selectAll();
    },
    methods: {
      onChange(index) {
        this.current = index;
      },
      selectAll() {
        selectAll().then((res) => {
          if (res.status) {
            this.columns = res.data;
            select(this.$route.params.id).then((res) => {
              if (res.status) {
                this.fom = res.data;
                this.columns.forEach((item) => {
                  if (this.fom.workOrderType == item.id) {
                    this.fom.workOrderType = item.name;
                  }
                });
              }
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
